<template>
    <div class="d-flex flex-column" style="width: 100%;">
        <!-- Header Section -->
        <div class="px-8 py-6 white mb-4 rounded-xl elevation-1 d-flex align-center">
            <v-avatar color="teal lighten-5" size="48" class="mr-4">
                <v-icon color="teal darken-2">mdi-folder-upload-outline</v-icon>
            </v-avatar>
            <div>
                <h2 class="text-h6 font-weight-bold teal--text text--darken-4 mb-0">QUẢN LÝ HỒ SƠ & TÀI LIỆU</h2>
                <p class="text-caption grey--text text--darken-1 mb-0">Hệ thống lưu trữ và quản lý tài liệu nhân sự tập trung</p>
            </div>
            <v-spacer></v-spacer>
            <v-chip color="teal lighten-5" text-color="teal darken-3" label small class="font-weight-bold">
                <v-icon left x-small>mdi-information-outline</v-icon> Chấp nhận: PDF, JPG, PNG
            </v-chip>
        </div>

        <!-- Mục 1: Hồ sơ định danh - Unified Upload Interface -->
        <v-card class="rounded-xl mx-auto mb-6 pt-2" flat style="width: 100%; border: 1px solid #e0f2f1;">
            <v-card-title class="text-subtitle-1 font-weight-bold teal--text text--darken-4 px-8" style="text-transform: uppercase;">
                <v-avatar size="28" class="rounded-lg mr-3" color="teal lighten-5">
                    <v-icon size="18px" color="teal darken-3">mdi-badge-account-outline</v-icon>
                </v-avatar> Hồ sơ định danh & Tài khoản
            </v-card-title>
            <v-card-text class="px-8 mt-2">
                <v-row class="my-0">
                    <v-col cols="12" sm="6" md="4" lg="3" v-for="(item, index) in idCards" :key="'id-'+index">
                        <div class="d-flex align-center mb-2">
                            <span class="text-subtitle-2 grey--text text--darken-3 font-weight-bold">{{ item.label }}</span>
                            <v-spacer></v-spacer>
                            <v-btn v-if="item.src && !item.src.includes('placehold.co')" icon x-small color="red" @click="$emit('delete', item.field)">
                                <v-icon x-small>mdi-close-circle</v-icon>
                            </v-btn>
                        </div>
                        <v-hover v-slot="{ hover }">
                            <v-sheet
                                height="180px"
                                class="d-flex flex-column align-center justify-center rounded-xl cursor-pointer transition-swing elevation-0"
                                :style="{
                                    border: '2px dashed ' + (item.src ? '#4DB6AC' : '#B2DFDB'),
                                    background: item.src ? '#F0F4F7' : '#F9FBFB',
                                    position: 'relative',
                                    overflow: 'hidden'
                                }"
                                @click="!lock && $refs[item.field + 'Input'][0].$refs.input.click()"
                            >
                                <!-- Image Preview -->
                                <v-img v-if="item.src && !item.src.includes('pdf')" :src="item.src" width="100%" height="100%" contain></v-img>
                                
                                <!-- PDF or Empty Placeholder -->
                                <div v-else class="d-flex flex-column align-center justify-center">
                                    <v-avatar size="84" color="white" class="elevation-2 mb-3">
                                        <v-icon size="42" :color="item.src ? 'teal darken-1' : 'teal lighten-3'">
                                            {{ item.src && item.src.includes('pdf') ? 'mdi-file-pdf-box' : (item.icon || 'mdi-cloud-upload-outline') }}
                                        </v-icon>
                                    </v-avatar>
                                    <span class="text-caption font-weight-bold" :class="item.src ? 'teal--text text--darken-2' : 'grey--text text--lighten-1'">
                                        {{ item.src ? 'TÀI LIỆU ĐÃ TẢI LÊN' : 'CHƯA CÓ DỮ LIỆU' }}
                                    </span>
                                </div>

                                <!-- Hover Overlay -->
                                <v-fade-transition>
                                    <div v-if="hover" class="d-flex align-center justify-center" style="position: absolute; top:0; left:0; width:100%; height:100%; background: rgba(0, 77, 64, 0.6);">
                                        <v-btn icon color="white" class="mx-1" @click.stop="$emit('view', item.src)" v-if="item.src && !item.src.includes('pdf')"><v-icon>mdi-eye-outline</v-icon></v-btn>
                                        <v-btn icon color="white" class="mx-1" @click.stop="$emit('download', item.src, item.filename)" v-if="item.src"><v-icon>mdi-download-outline</v-icon></v-btn>
                                        <v-btn icon color="white" class="mx-1" v-if="!lock"><v-icon>mdi-camera-outline</v-icon></v-btn>
                                    </div>
                                </v-fade-transition>
                                
                                <!-- Hidden File Input -->
                                <v-file-input :ref="item.field + 'Input'" class="d-none" hide-details @change="$emit('upload', $event, item.field)"></v-file-input>
                            </v-sheet>
                        </v-hover>
                    </v-col>
                </v-row>
            </v-card-text>
        </v-card>

        <!-- Mục 2: Hồ sơ tuyển dụng đính kèm -->
        <v-card class="rounded-xl mx-auto mb-6 pt-2" flat style="width: 100%; border: 1px solid #e0f2f1;">
            <v-card-title class="text-subtitle-1 font-weight-bold teal--text text--darken-4 px-8" style="text-transform: uppercase;">
                <v-avatar size="28" class="rounded-lg mr-3" color="teal lighten-5">
                    <v-icon size="18px" color="teal darken-3">mdi-text-box-check-outline</v-icon>
                </v-avatar> HỒ SƠ TUYỂN DỤNG ĐÍNH KÈM
            </v-card-title>
            <v-card-text class="px-8 mt-2">
                <v-row class="my-0">
                    <v-col cols="12" sm="6" md="4" lg="3" v-for="(item, index) in jobApplicationCards" :key="'job-'+index">
                        <div class="d-flex align-center mb-2">
                            <span class="text-subtitle-2 grey--text text--darken-3 font-weight-bold">{{ item.label }}</span>
                            <v-spacer></v-spacer>
                            <v-btn v-if="item.src" icon x-small color="red" @click="$emit('delete', item.field)">
                                <v-icon x-small>mdi-close-circle</v-icon>
                            </v-btn>
                        </div>
                        <v-hover v-slot="{ hover }">
                            <v-sheet
                                height="180px"
                                class="d-flex flex-column align-center justify-center rounded-xl cursor-pointer transition-swing elevation-0"
                                :style="{
                                    border: '2px dashed ' + (item.src ? '#4DB6AC' : '#B2DFDB'),
                                    background: item.src ? '#F0F4F7' : '#F9FBFB',
                                    position: 'relative',
                                    overflow: 'hidden'
                                }"
                                @click="!lock && $refs[item.field + 'Input'][0].$refs.input.click()"
                            >
                                <!-- Image Preview -->
                                <v-img v-if="item.src && !item.src.includes('pdf')" :src="item.src" width="100%" height="100%" contain></v-img>

                                <!-- PDF or Empty Placeholder -->
                                <div v-else class="d-flex flex-column align-center justify-center">
                                    <v-avatar size="84" color="white" class="elevation-2 mb-3">
                                        <v-icon size="42" :color="item.src ? 'teal darken-1' : 'teal lighten-3'">
                                            {{ item.src && item.src.includes('pdf') ? 'mdi-file-pdf-box' : (item.icon || 'mdi-file-document-outline') }}
                                        </v-icon>
                                    </v-avatar>
                                    <span class="text-caption font-weight-bold" :class="item.src ? 'teal--text text--darken-2' : 'grey--text text--lighten-1'">
                                        {{ item.src ? 'HỒ SƠ ĐÃ TẢI LÊN' : 'CHƯA CÓ TÀI LIỆU' }}
                                    </span>
                                </div>

                                <v-fade-transition>
                                    <div v-if="hover" class="d-flex align-center justify-center" style="position: absolute; top:0; left:0; width:100%; height:100%; background: rgba(0, 77, 64, 0.6);">
                                        <v-btn icon color="white" class="mx-1" @click.stop="$emit('view', item.src)" v-if="item.src && !item.src.includes('pdf')"><v-icon>mdi-eye-outline</v-icon></v-btn>
                                        <v-btn icon color="white" class="mx-1" @click.stop="$emit('download', item.src, item.filename)" v-if="item.src"><v-icon>mdi-download-outline</v-icon></v-btn>
                                        <v-btn icon color="white" class="mx-1" v-if="!lock"><v-icon>mdi-upload-outline</v-icon></v-btn>
                                    </div>
                                </v-fade-transition>
                                <v-file-input :ref="item.field + 'Input'" class="d-none" hide-details @change="$emit('upload', $event, item.field)"></v-file-input>
                            </v-sheet>
                        </v-hover>
                    </v-col>
                </v-row>
            </v-card-text>
        </v-card>

        <!-- Mục 3: Bằng cấp & Giấy tờ khác -->
        <v-card class="rounded-xl mx-auto mb-6 pt-2" flat style="width: 100%; border: 1px solid #e0f2f1;">
            <v-card-title class="text-subtitle-1 font-weight-bold teal--text text--darken-4 px-8" style="text-transform: uppercase;">
                <v-avatar size="28" class="rounded-lg mr-3" color="teal lighten-5">
                    <v-icon size="18px" color="teal darken-3">mdi-school-outline</v-icon>
                </v-avatar> Bằng cấp & Giấy tờ khác
            </v-card-title>
            <v-card-text class="px-8 mt-2">
                <v-row class="my-0">
                    <v-col cols="12" sm="6" md="4" lg="3" v-for="(item, index) in degreeCards" :key="'degree-'+index">
                        <div class="d-flex align-center mb-2">
                            <span class="text-subtitle-2 grey--text text--darken-3 font-weight-bold">{{ item.label }}</span>
                            <v-spacer></v-spacer>
                            <v-btn v-if="item.src" icon x-small color="red" @click="$emit('delete', item.field, item.index)">
                                <v-icon x-small>mdi-close-circle</v-icon>
                            </v-btn>
                        </div>
                        <v-hover v-slot="{ hover }">
                            <v-sheet
                                height="180px"
                                class="d-flex flex-column align-center justify-center rounded-xl cursor-pointer transition-swing elevation-0"
                                :style="{
                                    border: '2px dashed ' + (item.src ? '#4DB6AC' : '#B2DFDB'),
                                    background: item.src ? '#F0F4F7' : '#F9FBFB',
                                    position: 'relative',
                                    overflow: 'hidden'
                                }"
                                @click="!lock && $refs[item.field + 'Input'][0].$refs.input.click()"
                            >
                                <!-- Image Preview -->
                                <v-img v-if="item.src && !item.src.includes('pdf')" :src="item.src" width="100%" height="100%" contain></v-img>

                                <!-- PDF or Empty Placeholder -->
                                <div v-else class="d-flex flex-column align-center justify-center">
                                    <v-avatar size="84" color="white" class="elevation-2 mb-3">
                                        <v-icon size="42" :color="item.src ? 'teal darken-1' : 'teal lighten-3'">
                                            {{ item.src && item.src.includes('pdf') ? 'mdi-file-pdf-box' : (item.icon || 'mdi-certificate-outline') }}
                                        </v-icon>
                                    </v-avatar>
                                    <span class="text-caption font-weight-bold" :class="item.src ? 'teal--text text--darken-2' : 'grey--text text--lighten-1'">
                                        {{ item.src ? 'BẰNG CẤP ĐÃ TẢI LÊN' : 'CHƯA CÓ TÀI LIỆU' }}
                                    </span>
                                </div>

                                <v-fade-transition>
                                    <div v-if="hover" class="d-flex align-center justify-center" style="position: absolute; top:0; left:0; width:100%; height:100%; background: rgba(0, 77, 64, 0.6);">
                                        <v-btn icon color="white" class="mx-1" @click.stop="$emit('view', item.src)" v-if="item.src && !item.src.includes('pdf')"><v-icon>mdi-eye-outline</v-icon></v-btn>
                                        <v-btn icon color="white" class="mx-1" @click.stop="$emit('download', item.src, item.filename)" v-if="item.src"><v-icon>mdi-download-outline</v-icon></v-btn>
                                        <v-btn icon color="white" class="mx-1" v-if="!lock"><v-icon>mdi-upload-outline</v-icon></v-btn>
                                    </div>
                                </v-fade-transition>
                                <v-file-input :ref="item.field + 'Input'" class="d-none" hide-details @change="$emit('upload', $event, item.field)"></v-file-input>
                            </v-sheet>
                        </v-hover>
                    </v-col>
                </v-row>
            </v-card-text>
        </v-card>
    </div>
</template>
<script>
export default {
    name: 'TabAttachment',
    props: {
        lock: Boolean,
        idCards: Array,
        jobApplicationCards: Array,
        degreeCards: Array,
    }
}
</script>
